import React, { useState } from 'react';
import { Grid, Button } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterDialog from '../../components/common/FilterButton/FilterDialog';

const MasterAttributesFilter = (props) => {
    const { filters, onFiltersApply, onFiltersClear, filterProperties, initialFilters } = props;
    const [openFilterDialog, setOpenFilterDialog] = useState(false);

    return (
        <Grid container spacing={1} direction="row-reverse" justifyContent="flex-start" alignItems="center">
            <Grid item alignContent="flex-end" xs="auto">
                <Button
                    color="primary"
                    disabled={false}
                    onClick={() => setOpenFilterDialog(true)}
                    startIcon={<FilterAltIcon />}
                    size="medium"
                    variant={filters.length ? 'contained' : 'text'}
                >
                    Filter
                </Button>
                <FilterDialog
                    enableAddButton={false}
                    onApply={onFiltersApply}
                    onClear={onFiltersClear}
                    onClose={() => setOpenFilterDialog(false)}
                    open={openFilterDialog}
                    operators={[]}
                    properties={filterProperties}
                    initialFilters={initialFilters}
                />
            </Grid>
        </Grid>
    );
};

export default MasterAttributesFilter;
